export type ServiceLogTypeEnum = 'DEBUG' | 'INFO' | 'ERROR' | 'NOTIFICATION';
export const ServiceLogTypeEnum = {
  DEBUG: 'DEBUG' as ServiceLogTypeEnum,
  INFO: 'CUSTOMER_INFO' as ServiceLogTypeEnum,
  ERROR: 'CUSTOMER_ERROR' as ServiceLogTypeEnum,
  NOTIFICATION: 'NOTIFICATION' as ServiceLogTypeEnum,
};
